import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { setCookie } from "../../helpers/session";

export const loginSlice = createSlice({
	name: "login",
	initialState: {
		loginInfo: [],
		errors: [],
	},
   
	reducers: {
		getLoginInfo: (state, action) => {
			state.loginInfo = action.payload
			// console.log(action, "reducer")
			
		},

		getLoginInfoSuccess: (state, action) => {
			 
			state.loginInfo = action.payload
			// console.log(action.payload, "reducer")
			setCookie("refresh_token", action.payload.data.data.refresh)
			setCookie("access_token", action.payload.data.data.access)
			
			
		},

		getErrors: (state, action) => {
			state.errors = action.payload.response.data
			// console.log(state.errors.detail, "reducer")
			if(state.errors.detail){
				toast.error(`${state.errors.detail}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
				
			}else if(state.errors.password){
				// console.log(state.errors.password)
					 toast.error(`${state.errors.password}`, {
						position: "top-right",
						autoClose: 1500,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					})
			}

			}
		
	},
	

})


export const {getLoginInfo, getErrors, getLoginInfoSuccess} = loginSlice.actions

export default loginSlice.reducer
